import {Component, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Constant} from '../../../../global/util/Constant';
import {ConfirmComponent} from '../../../../shared/confirm/confirm.component';
import {Response} from '../../../../global/util/enum/Response';
import {InformType} from '../../../../global/util/enum/InformType';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-preview-template-workflow',
  templateUrl: './preview-template-workflow.component.html',
  styleUrls: ['./preview-template-workflow.component.css']
})
export class PreviewTemplateWorkflowComponent implements OnInit {

  public entityName = 'TITLE.PREVIEW';
  public workflowReceived: any;
  public urlStream;
  public loading = false;

  constructor(private modalService: NgbModal,
              public activeModal: NgbActiveModal,
              private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.urlStream = this.workflowReceived._links.templatestream.href.replace('http', Constant.SCHEMA);
  }

  public save() {
    const modalRef = this.modalService.open(ConfirmComponent);
    modalRef.componentInstance.title = this.translate.instant('TITLE.PREVIEW');
    modalRef.componentInstance.body = this.translate.instant('QUESTION.DO-YOU-WANT-SAVE-AND-CLOSET-THE-TEMPLATE');
    modalRef.result.then((result) => {
      if (Response.Yes === result) {
        this.activeModal.close(InformType.Success);
      }
    });
  }

  public edit() {
    this.activeModal.close(PreviewTemplateWorkflowComponent);
  }
}
